import { useAuthenticatedQuery, useAuthenticatedQueries } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

export function useRoadworksQuery(
    url,
    queryKey,
    queryParameters,
    config = {},
    initialData,
) {
    const apiUrl = `roadwork/${url}`
    const { enabled = true, addProjectParam = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    if (addProjectParam) {
        queryKey.push({ network: selectedNetwork?.slug })
    }

    return useAuthenticatedQuery(
        apiUrl,
        queryKey,
        { ...queryParameters, ...(addProjectParam && { project: selectedNetwork?.slug }) },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
        initialData,
    )
}

export function useRoadworksQueries(queriesData) {
    const { selectedNetwork } = useNetworksStateContext()

    const overridedQueriesData = queriesData.map(queryData => {
        queryData.queryKey.push({ network: selectedNetwork?.slug })
        const { enabled = true } = queryData.config
        const newConfig = {
            ...queryData.config,
            enabled: !!selectedNetwork?.slug && enabled,
        }

        return {
            url: `roadwork/${queryData.url}`,
            queryKey: queryData.queryKey,
            queryParameters: { ...queryData.queryParameters, project: selectedNetwork?.slug },
            ...newConfig,
        }
    })

    return useAuthenticatedQueries(overridedQueriesData)
}